import { QueryParams, axiosInstance } from './req';
import { Paginated } from '@/types/pagination';
import { PricingResolved } from '@/types/pricing-plan';
import { UserInfo } from '@/types/user-info';
import { Subscription } from '@/types/subscriptions';

export const loadResolvedPlans = async (
    { page, perPage, filter, userId }: QueryParams & { userId?: string },
    deviceID: string,
): Promise<
    Paginated<PricingResolved & { user?: UserInfo }> & {
        user?: UserInfo;
    }
> => {
    return axiosInstance
        .get('/api/v2/subscriptions/plans', { params: { page, perPage, filter, userId, deviceID } })
        .then(({ data }) => data);
};

export const subscribeUser = async (
    user: UserInfo,
    subscriptionPlanId: string,
    deviceUUID: string,
    oldSubscriptionId: string | null,
    isUpgrade: boolean,
    couponCode: string,
    paymentMethod: string,
): Promise<Subscription> => {
    return axiosInstance
        .post(`/api/v2/subscriptions/${subscriptionPlanId}/subscribe`, {
            userId: user._id,
            deviceUUID,
            oldSubscriptionId,
            isUpgrade,
            couponCode,
            paymentMethod
        })
        .then(({ data }) => data);
};

export const k9SubscribeUser = async (
    user: UserInfo,
    subscriptionPlanId: string,
    deviceUUID: string,
    oldSubscriptionId: string | null,
    isUpgrade: boolean,
    couponCode: string,
    paymentMethod: string,
    ExtraFeeCharge: number,
): Promise<Subscription> => {
    return axiosInstance
        .post(`/api/v2/subscriptions/k9-user/${subscriptionPlanId}/subscribe`, {
            userId: user._id,
            deviceUUID,
            oldSubscriptionId,
            isUpgrade,
            couponCode,
            paymentMethod,
            ExtraFeeCharge,
        })
        .then(({ data }) => data);
};

export const pauseSubscription = async (subscriptionId: string, resumeDate: Date) => {
    return axiosInstance.put(`/api/v2/subscriptions/${subscriptionId}/pause`, { resumeDate }).then(({ data }) => data);
};

export const resumeSubscription = async (subscriptionId: string) => {
    return axiosInstance.put(`/api/v2/subscriptions/${subscriptionId}/resume`).then(({ data }) => data);
};

export const cancelSubscription = async (subscriptionId: string) => {
    return axiosInstance.put(`/api/v2/subscriptions/${subscriptionId}/cancel`).then(({ data }) => data);
};

export const loadUserCurrentSubscriptions = async () => {
    return axiosInstance.get('api/v2/subscriptions/current').then(({ data }) => {
        return data.subscriptions;
    });
};

export const loadUserSubscriptions = async (userId: string) => {
    return axiosInstance.get(`api/v2/subscriptions/user?userId=${userId}`).then(({ data }) => {
        return data.subscriptions;
    });
};

export const validateCoupon = async (code: string, deviceUUID: string, productId?: string) => {
    return axiosInstance.get(`api/coupon/apply/${code}/${deviceUUID}/${productId}`).then(({ data }) => data.coupon);
};

export const createPaymentIntent = async () => {
    return axiosInstance.post(`api/v2/create-payment-intent`).then(({ data }) => {
        return data;
    });
};
